// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { jbcTestnet as _jbcTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the jbcTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 88991
 * Chain Name: Jibchain Testnet
 * Default Block Explorer: https://exp.testnet.jibchain.net
 * Default RPC URL: https://rpc.testnet.jibchain.net
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { jbcTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: jbcTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const jbcTestnet = createCommon({
	..._jbcTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
